// extracted by mini-css-extract-plugin
module.exports = {"switch":"rounded-toggle_switch__AF8yX","cimSwitch":"rounded-toggle_cimSwitch__B1H6y","slider":"rounded-toggle_slider__HGRSd","round":"rounded-toggle_round__g2xTI"};